import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function CaliforniaForm(props) {
  const { version } = props;
  const isVersion2025OrLater = ['12_24'].includes(version);

  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default CaliforniaForm;
